import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import IconButton from "@material-ui/core/IconButton";

import SearchIcon from "@material-ui/icons/Search";
import CreditCardTwoTone from "@material-ui/icons/CreditCardTwoTone";
import CCTMovimientosTable from "./CCTMovimientosTable";
import "../CCTCuenta/pagar.css";
import Pagotarjeta from "./PagoTarjeta";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "14px",
  },
  table: {
    fontSize: "14px",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#15b3e8",
    color: theme.palette.common.white,
    fontWeight: "bold",
    fontFamily: "Gotham",
    fontSize: 15,
    borderBottom: "7px solid white",
    width: "100px",
  },
  body: {
    fontSize: 15,
    fontFamily: "Gotham",
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#0489c0",
      fontSize: 15,
      borderBottom: "5px solid white",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#15b3e8",
      fontSize: 15,
      borderBottom: "5px solid white",
    },
  },
}))(TableRow);

export default observer(function PerfilPago() {
  const classes = useStyles();
  const {
    userStore: { user, logout, isLoggedIn, roles, loadNotificar },
  } = useStore();
  const nf = new Intl.NumberFormat("en-IN");
  const { CCTCuentaStore, modalStore } = useStore();
  const { loadCCTCuenta, CCTCuentaByCodigo, saldo_actual_total } =
    CCTCuentaStore;
  var id: string | undefined = user?.id;

  useEffect(() => {
    if (id) {
      loadCCTCuenta(id);
    }
  }, [id, loadCCTCuenta]);

  function Saldo() {
    const valorInput = (
      document.getElementById("idCliente") as HTMLInputElement
    ).value;
    if (valorInput.length == 13) {
    }
  }

  if (CCTCuentaStore.loadingInitial)
    return <LoadingComponent content="Cargando datos.." />;

  return (
    <>
      <br></br>
      {CCTCuentaByCodigo.map((cuentas) => {
        var fecha_Movimiento = cuentas.fechaUltimoMovimiento.split("-", 3);
        var dia = fecha_Movimiento[2].split("T", 2);
        var saldo = nf.format(cuentas.saldoActual);
        if (cuentas.saldoActual % 1 == 0) {
          saldo = saldo + ".00";
        }
        return (
          <Pagotarjeta
            cliente={cuentas.cuenta}
            cuenta={cuentas.cuenta}
            saldo={cuentas.saldoActual}
            descripcion={cuentas.descripcion}
          />
        );
      })}
    </>
  );
});
